import { render, staticRenderFns } from "./ExtendOpen.vue?vue&type=template&id=231864c4&scoped=true"
import script from "./ExtendOpen.vue?vue&type=script&lang=js"
export * from "./ExtendOpen.vue?vue&type=script&lang=js"
import style0 from "./ExtendOpen.vue?vue&type=style&index=0&id=231864c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231864c4",
  null
  
)

export default component.exports